import {MDBCard, MDBCardBody, MDBCardText, MDBCol, MDBRow} from 'mdb-react-ui-kit';
import { useContext, useEffect, useState } from 'react';
import { Container} from 'react-bootstrap';
import api from '../../app/api/agent'
import { GlobalStateContext } from '../../store/GlobalState';
import CustomNavBar from '../../components/CustomNavBar';
//import Cookies from 'js-cookie';

function UserInfo() {

    const [UserInfo, setUserInfo] = useState<{ [x: string]: any } | undefined>(undefined)
    
    const globalState = useContext(GlobalStateContext);
    useEffect(()=>{
        
        if(localStorage.accessToken){
            api.get(`/Account/userInfo`).then((response)=>{
                    if (response.status !== 200){
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")
                        globalState?.setAccessToken('');
                        window.location.href='/'
                    }else{
                        setUserInfo(response.data)
                    }
                    }).catch(()=>{
                        localStorage.removeItem("accessToken")
                        localStorage.removeItem("refreshToken")
                        localStorage.removeItem("expireAt")
                        localStorage.removeItem("role")

                        globalState?.setAccessToken('');
                        window.location.href='/'
                    })
        }else{
          api.get("/OIDC/getUserInfo",{withCredentials: true,}).then((response)=>{
                    if (response.status !== 200){
                            window.location.href='/'
                    }else{
                        setUserInfo(response.data)
                    }
                    }).catch(()=>{
                        window.location.href='/'
                })
        }


    },[globalState])


  return (
    <Container style={{padding: 0, fontFamily:"Poppins", width:"95%", height:"100vh", background:"linear-gradient(45deg,rgba(255, 255, 255, 1) 0%, rgba(245, 255, 247, 1) 50%, rgba(222, 255, 232, 1) 100%)"}}>
    
    <CustomNavBar></CustomNavBar>
    <MDBCard className="mb-4" style={{width:"95%", margin:"auto"}}>
              <MDBCardBody>
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Full Name</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">{UserInfo === undefined ? "" : UserInfo!["name"] === null ? "" : UserInfo!["name"].toString()}</MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Email</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">{UserInfo === undefined ? "" : UserInfo!["email"] === null ? "" : UserInfo!["email"].toString()}</MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Company</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">{UserInfo === undefined ? "" : UserInfo!["company"] === null ? "" : UserInfo!["company"].toString()}</MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Phone</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">{UserInfo === undefined ? "" : UserInfo!["phoneNumer"] === null ? "" : UserInfo!["phoneNumer"].toString()}</MDBCardText>
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  <MDBCol sm="3">
                    <MDBCardText>Role</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="9">
                    <MDBCardText className="text-muted">{UserInfo === undefined ? "" : UserInfo!["role"] === null ? "" : UserInfo!["role"].toString()}</MDBCardText>
                  </MDBCol>
                </MDBRow>
              </MDBCardBody>
            </MDBCard>

    </Container>
  );
}

export default UserInfo;